/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedCancelledRouteImport } from './routes/_authed/cancelled'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedReportsRouteImport } from './routes/_authed/reports'
import { Route as AuthedAdminAdminSyncRouteImport } from './routes/_authed/admin/admin-sync'
import { Route as AuthedAdminClustersRouteImport } from './routes/_authed/admin/clusters'
import { Route as AuthedAdminFacilitiesRouteImport } from './routes/_authed/admin/facilities'
import { Route as AuthedAdminRolesRouteImport } from './routes/_authed/admin/roles'
import { Route as AuthedAdminSettingsRouteImport } from './routes/_authed/admin/settings'
import { Route as AuthedAdminUsersRouteImport } from './routes/_authed/admin/users'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCancelledRoute = AuthedCancelledRouteImport.update({
  id: '/cancelled',
  path: '/cancelled',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsRoute = AuthedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminAdminSyncRoute = AuthedAdminAdminSyncRouteImport.update({
  id: '/admin/admin-sync',
  path: '/admin/admin-sync',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminClustersRoute = AuthedAdminClustersRouteImport.update({
  id: '/admin/clusters',
  path: '/admin/clusters',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminFacilitiesRoute = AuthedAdminFacilitiesRouteImport.update({
  id: '/admin/facilities',
  path: '/admin/facilities',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRolesRoute = AuthedAdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminSettingsRoute = AuthedAdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminUsersRoute = AuthedAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/cancelled': typeof AuthedCancelledRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/reports': typeof AuthedReportsRoute
  '/admin/admin-sync': typeof AuthedAdminAdminSyncRoute
  '/admin/clusters': typeof AuthedAdminClustersRoute
  '/admin/facilities': typeof AuthedAdminFacilitiesRoute
  '/admin/roles': typeof AuthedAdminRolesRoute
  '/admin/settings': typeof AuthedAdminSettingsRoute
  '/admin/users': typeof AuthedAdminUsersRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/cancelled': typeof AuthedCancelledRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/reports': typeof AuthedReportsRoute
  '/': typeof AuthedIndexRoute
  '/admin/admin-sync': typeof AuthedAdminAdminSyncRoute
  '/admin/clusters': typeof AuthedAdminClustersRoute
  '/admin/facilities': typeof AuthedAdminFacilitiesRoute
  '/admin/roles': typeof AuthedAdminRolesRoute
  '/admin/settings': typeof AuthedAdminSettingsRoute
  '/admin/users': typeof AuthedAdminUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/cancelled': typeof AuthedCancelledRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/reports': typeof AuthedReportsRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/admin/admin-sync': typeof AuthedAdminAdminSyncRoute
  '/_authed/admin/clusters': typeof AuthedAdminClustersRoute
  '/_authed/admin/facilities': typeof AuthedAdminFacilitiesRoute
  '/_authed/admin/roles': typeof AuthedAdminRolesRoute
  '/_authed/admin/settings': typeof AuthedAdminSettingsRoute
  '/_authed/admin/users': typeof AuthedAdminUsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/cancelled'
    | '/dashboard'
    | '/reports'
    | '/admin/admin-sync'
    | '/admin/clusters'
    | '/admin/facilities'
    | '/admin/roles'
    | '/admin/settings'
    | '/admin/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/cancelled'
    | '/dashboard'
    | '/reports'
    | '/'
    | '/admin/admin-sync'
    | '/admin/clusters'
    | '/admin/facilities'
    | '/admin/roles'
    | '/admin/settings'
    | '/admin/users'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/cancelled'
    | '/_authed/dashboard'
    | '/_authed/reports'
    | '/_authed/'
    | '/_authed/admin/admin-sync'
    | '/_authed/admin/clusters'
    | '/_authed/admin/facilities'
    | '/_authed/admin/roles'
    | '/_authed/admin/settings'
    | '/_authed/admin/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cancelled': {
      id: '/_authed/cancelled'
      path: '/cancelled'
      fullPath: '/cancelled'
      preLoaderRoute: typeof AuthedCancelledRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reports': {
      id: '/_authed/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/admin-sync': {
      id: '/_authed/admin/admin-sync'
      path: '/admin/admin-sync'
      fullPath: '/admin/admin-sync'
      preLoaderRoute: typeof AuthedAdminAdminSyncRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/clusters': {
      id: '/_authed/admin/clusters'
      path: '/admin/clusters'
      fullPath: '/admin/clusters'
      preLoaderRoute: typeof AuthedAdminClustersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/facilities': {
      id: '/_authed/admin/facilities'
      path: '/admin/facilities'
      fullPath: '/admin/facilities'
      preLoaderRoute: typeof AuthedAdminFacilitiesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/roles': {
      id: '/_authed/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AuthedAdminRolesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/settings': {
      id: '/_authed/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthedAdminSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/users': {
      id: '/_authed/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthedAdminUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedCancelledRoute: typeof AuthedCancelledRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedReportsRoute: typeof AuthedReportsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAdminAdminSyncRoute: typeof AuthedAdminAdminSyncRoute
  AuthedAdminClustersRoute: typeof AuthedAdminClustersRoute
  AuthedAdminFacilitiesRoute: typeof AuthedAdminFacilitiesRoute
  AuthedAdminRolesRoute: typeof AuthedAdminRolesRoute
  AuthedAdminSettingsRoute: typeof AuthedAdminSettingsRoute
  AuthedAdminUsersRoute: typeof AuthedAdminUsersRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedCancelledRoute: AuthedCancelledRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedReportsRoute: AuthedReportsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAdminAdminSyncRoute: AuthedAdminAdminSyncRoute,
  AuthedAdminClustersRoute: AuthedAdminClustersRoute,
  AuthedAdminFacilitiesRoute: AuthedAdminFacilitiesRoute,
  AuthedAdminRolesRoute: AuthedAdminRolesRoute,
  AuthedAdminSettingsRoute: AuthedAdminSettingsRoute,
  AuthedAdminUsersRoute: AuthedAdminUsersRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
